import { render } from "./AppTerms.vue?vue&type=template&id=2f15fa08"
import script from "./AppTerms.vue?vue&type=script&lang=js"
export * from "./AppTerms.vue?vue&type=script&lang=js"

import "./AppTerms.vue?vue&type=style&index=0&id=2f15fa08&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__